import { ReactNode } from "react";
import styles from "./menu-select-section.module.css";

export type MenuSelectSectionProps = {
  children: ReactNode;
};

export function MenuSelectSection({ children }: MenuSelectSectionProps) {
  return <div className={styles.Container}>{children}</div>;
}
